// Fixed set of conferences accepting paper-presentation video submissions.
// Kept in sync manually with eventshouse-api's
// src/constants/paperVideoConferences.ts (no shared package between the repos).

export const PAPER_VIDEO_CONFERENCES = {
  DTPI_2026:
    "The 6th Annual IEEE International Conference on Digital Twins and Parallel Intelligence (DTPI 2026)",
  ISI_2026:
    "IEEE International Conference on Intelligence and Security Informatics (ISI 2026)",
  CPSI_2026: "Cyber-Physical Social Intelligence (CPSI 2026)",
} as const;

export type PaperVideoConferenceCode = keyof typeof PAPER_VIDEO_CONFERENCES;

export const PAPER_VIDEO_CONFERENCE_OPTIONS = (
  Object.keys(PAPER_VIDEO_CONFERENCES) as PaperVideoConferenceCode[]
).map((code) => ({ code, label: PAPER_VIDEO_CONFERENCES[code] }));

export function paperVideoConferenceLabel(code: string): string {
  return (
    PAPER_VIDEO_CONFERENCES[code as PaperVideoConferenceCode] ?? code
  );
}
